import React from 'react';
import { Typography } from '@mui/material';
import { SectionPaper } from '../../../../common/components/styled-ui-elements';

interface ComplianceEmptyStateProps {
  message?: string;
}

/**
 * ComplianceEmptyState - Shared empty state displayed when no compliance items match the current filter
 */
const ComplianceEmptyState: React.FC<ComplianceEmptyStateProps> = ({
  message = 'No compliance requirements found.',
}) => {
  return (
    <SectionPaper>
      <Typography variant="body2" sx={{ color: '#64748b', textAlign: 'center', py: 4 }}>
        {message}
      </Typography>
    </SectionPaper>
  );
};

export default ComplianceEmptyState;
